<template>
  <div class="nav-top clearfix">
    <div class="title"
         @click="topClick">{{commonTitle}}</div>
    <div class="user">
      <img :src="require('@/assets/images/menuIcon/u@2x(1).png')" />
      <!-- <span class="username">{{user}}</span> -->
      <el-dropdown @command="handleCommand"
                   trigger="click">
        <span class="el-dropdown-link">
          <span class="username">{{user}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a">个人中心</el-dropdown-item>
          <el-dropdown-item command="c">修改密码</el-dropdown-item>
          <el-dropdown-item command="d">安全退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <span class="line">|</span>
      <span class="loginout" @click="loginOut">退出登录</span>-->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ['isReport'],
  data () {
    return {
      user: ""
    };
  },

  created () {
    this.user = this.Cookies.get("legalName");
  },

  methods: {
    topClick () {
      this.$router.push("/UC/User");
    },
    loginOut () {
      const code = this.Cookies.get("identifyCode");
      let loginPath = "/Login";
      if (code && code.slice(0, 2) == "WR") loginPath = "/ReportLogin";

      this.Cookies.remove("legalName");
      this.Cookies.remove("registedType");

      this.Cookies.remove("institutionName");
      this.Cookies.remove("identifyCode");
      this.Cookies.remove("riskToken");
      this.$router.push(loginPath);
    },

    handleCommand (command) {

      if (!this.isReport) {
        if (command == "a") {
          this.$router.push("/UC/Center/UserCenter");
        } else if (command == "c") {
          this.$router.push("/UC/Center/PsdEdit");
        } else this.loginOut();
      } else {
        if (command == "a") {
          this.$router.push("/UC/Center/UserCenter");
        } else if (command == "c") {
          this.$router.push("/UC/Center/PsdEdit")
        } else this.$router.push("/reportLogin/Login")
      }

    }
  },

  computed: {
    ...mapState({
      commonTitle (state) {
        return state.Title.title;
      }
    })
  }
};
</script>

<style lang="scss" scoped>
.title {
  float: left;
  font-size: 20px;
}
.user {
  float: right;
}
img {
  width: 35px;
  margin-right: 10px;
}
.line {
  margin: 0px 10px;
}
.loginout {
  cursor: pointer;
}
.username,
i {
  color: #ffffff !important;
}
.el-dropdown-menu {
  width: 139px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  padding: 20px 0;
  .el-dropdown-menu__item:nth-last-child(2) {
    padding-bottom: 0;
  }
}

.el-dropdown-menu__item:not(.is-disabled) {
  font-size: 16px;
  line-height: 16px;
  padding: 0 38px;
  font-family: AlibabaM;
  padding-bottom: 24px;
  text-align: center;
  white-space: nowrap;
  color: #191818;
  background-color: transparent;
}
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #008fff;
  background-color: transparent;
}
</style>

